export default {
  data () {
    return {
      additionalUserInfo: {}
    }
  },
  methods: {
    getUserOS () {
      const platform = navigator.platform
      if (platform.indexOf('Win') !== -1) return 'Windows'
      if (platform.indexOf('Mac') !== -1) return 'Mac OS'
      if (platform.indexOf('Linux') !== -1) return 'Linux'
      return 'Unknown'
    },
    getBrowser () {
      let browser = 'Unknown'
      if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
        browser = 'Opera'
      } else if (navigator.userAgent.indexOf('Edg') !== -1) {
        browser = 'Edge'
      } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
        browser = 'Chrome'
      } else if (navigator.userAgent.indexOf('Safari') !== -1) {
        browser = 'Safari'
      } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
        browser = 'Firefox'
      } else if ((navigator.userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) {
        browser = 'Edge'
      }
      return browser
    },
    userRecentURLS () {
      const recentUrls = 'fs_recent_urls'
      if (localStorage?.[recentUrls]) {
        const urls = JSON.parse(localStorage[recentUrls])
        return Object.keys(urls).map(function (e) { return '<a href="' + urls[e] + '" title="' + e + ' ' + urls[e] + '"/>' }).join('|')
      } else {
        return 'No recent URLs'
      }
    },
    addAdditionsParameters () {
      this.additionalUserInfo.genesysOS = this.getUserOS()
      this.additionalUserInfo.genesysBrowser = this.getBrowser()
      this.additionalUserInfo.customerLastURLs = this.userRecentURLS()
    }
  }
}
